export const Subpage = {
  defineNodes: ['Subpage'],
  parseInline: [{
    name: 'Subpage',
    before: 'HTMLTag',
    parse(context, next, pos) {
      if (next === 91) { // code 91 is character [
        const editorString = context.slice(pos, Math.min(pos + 64, context.end));
        return parsedSubpage(context, pos, editorString);
      }
    }
  }]
};

function parsedSubpage(context, pos, editorString) {
  const match = /^\[\[.*?]]/.exec(editorString);
  if (match) {
    const [subpage] = match;
    return subpageElement(context, subpage, pos);
  }
}

function subpageElement(context, subpage, pos) {
  return context.addElement(context.elt('Subpage', pos, pos + subpage.length));
}
